const containsPersian = value =>
  typeof value === "string" && /[\u0600-\u06ff]/.test(value);

const statusMessages = {
  400: "اطلاعات ارسال‌شده معتبر نیست. لطفاً دوباره بررسی کنید.",
  401: "نشست شما منقضی شده است. لطفاً دوباره وارد شوید.",
  403: "شما اجازه انجام این عملیات را ندارید.",
  404: "اطلاعات موردنظر پیدا نشد.",
  405: "امکان انجام این عملیات وجود ندارد.",
  409: "این درخواست با وضعیت فعلی قابل انجام نیست.",
  422: "بعضی از اطلاعات واردشده معتبر نیست. لطفاً فرم را بررسی کنید.",
  429: "تعداد درخواست‌ها زیاد است. لطفاً کمی بعد دوباره تلاش کنید.",
  500: "در پردازش درخواست خطایی رخ داد. لطفاً دوباره تلاش کنید.",
  502: "سرویس موقتاً در دسترس نیست. لطفاً کمی بعد دوباره تلاش کنید.",
  503: "سرویس موقتاً در دسترس نیست. لطفاً کمی بعد دوباره تلاش کنید.",
  504: "پاسخ سرور بیش از حد طول کشید. لطفاً دوباره تلاش کنید.",
};

const firstValidationMessage = error => {
  const errors = error?.response?.data?.errors;
  if (!errors || typeof errors !== "object") return null;

  const firstError = Object.values(errors)[0];
  return Array.isArray(firstError) ? firstError[0] : firstError;
};

export const isUnauthorizedApiError = error => error?.response?.status === 401;

export const getPersianApiErrorMessage = (
  error,
  fallback = "انجام درخواست با خطا مواجه شد.",
) => {
  const validationMessage = firstValidationMessage(error);
  if (containsPersian(validationMessage)) return validationMessage;

  const serverMessage = error?.response?.data?.message;
  if (containsPersian(serverMessage)) return serverMessage;

  const status = error?.response?.status;
  if (statusMessages[status]) return statusMessages[status];

  if (!error?.response) {
    return "ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی و دوباره تلاش کنید.";
  }

  return fallback;
};
